export const SUCCESS = 'success';
export const DANGER = 'danger';
export const WARNING = 'warning';
export const INFO = 'info';



// WEBPACK FOOTER //
// ./src/constants/AlertTypes.js